<template>
  <Box class="relative col-span-full overflow-hidden">
    <img
      v-if="!isLoading"
      :src="IntersectPath"
      alt="Intersect"
      class="absolute -right-16 -top-16 z-0 md:right-0 md:top-0"
    />
    <div class="flex flex-col gap-4">
      <CardLoaderSmall v-if="isLoading" class="flex-1 flex-col !p-0 !ring-0" />
      <template v-else>
        <h2 class="text-t4 z-10 mb-4 flex items-center gap-4">
          <IconQuePoints class="sm:w-[50px] sm:h-[50px] w-59px] h-[59px]" />
          Köpoäng
        </h2>
        <div class="relative z-10 flex flex-col">
          <div class="grid grid-cols-2 gap-8 py-8 md:grid-cols-4 md:gap-2">
            <div
              class="flex flex-col items-center justify-center"
              v-if="!!queuePoints || queuePoints === 0"
            >
              <span class="text-t5 text-gray-dark">Bostad</span>
              <span class="text-t2">{{ queuePoints }}</span>
            </div>
            <div
              class="flex flex-col items-center justify-center"
              v-if="!!queuePointsStudent || queuePointsStudent === 0"
            >
              <span class="text-t5 text-gray-dark">Studentbostad</span>
              <span class="text-t2">{{ queuePointsStudent }}</span>
            </div>
            <div
              class="flex flex-col items-center justify-center"
              v-if="!!queuePointsParking || queuePointsParking === 0"
            >
              <span class="text-t5 text-gray-dark">Fordonsplats</span>
              <span class="text-t2">{{ queuePointsParking }}</span>
            </div>
            <div
              class="flex flex-col items-center justify-center"
              v-if="!!queuePointsPremise || queuePointsPremise === 0"
            >
              <span class="text-t5 text-gray-dark">Förråd</span>
              <span class="text-t2">{{ queuePointsPremise }}</span>
            </div>
          </div>
          <div class="mb-4 rounded-md bg-gray-10 p-4">
            För att stå kvar i kön och behålla dina köpoäng måste du logga in igen senast den
            {{ formattedYYMMDDDate(latestLogin) }}.
            <br />
            <a href="/hyr-bostad/sa-gar-det-till-att-hyra-bostad/">
              Mer information om att hyra hos oss
            </a>
          </div>
          <Button variant="tertiary" href="/sok-ledigt" class="self-end">
            Gå till sök ledigt
            <template #icon-after>
              <IconArrowRight />
            </template>
          </Button>
        </div>
      </template>
    </div>
  </Box>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import dayjs from 'dayjs';
import Box from '@/components/ui/box';
import Button from '@/components/ui/button';
import IconArrowRight from '@/components/icons/IconArrowRight';
import IconQuePoints from '@/components/icons/IconQuePoints';
import CardLoaderSmall from '@/components/loader/CardLoaderSmall';

export default {
  name: 'dashboard',
  props: {
    startLoading: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Box,
    Button,
    IconArrowRight,
    IconQuePoints,
    CardLoaderSmall,
  },
  data() {
    return {
      loaded: [],
      isLoading: true,
      IntersectPath: 'https://tstabgmypagescode.blob.core.windows.net/test-exit-xpand/drop/static/images/Intersect.png',
      // testAlwaysLoading: true,
    };
  },
  watch: {
    startLoading: {
      immediate: true,
      handler(val) {
        if (val === true) {
          new Promise((resolve) => setTimeout(resolve, 500)).then(() => {
            this.$store.cache.dispatch('fetchProfile').then((data) => {
              this.$store.cache.dispatch('getQueuePoints', data.contactCode).finally(() => {
                this.isLoading = false;
                this.loaded.push('queuePoints');
              });
            });
          });
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      profile: 'profile',
      queuePoints: 'queuePoints',
      queuePointsStudent: 'queuePointsStudent',
      queuePointsParking: 'queuePointsParking',
      queuePointsPremise: 'queuePointsPremise',
    }),
    latestLogin() {
      return dayjs(new Date()).add(365, 'days');
    },
  },

  created() {
  },

  methods: {
    formattedYYMMDDDate(date) {
      return dayjs(date).format('DD MMMM YYYY');
    },
  },
};
</script>
